import styled from 'styled-components';

export const SectionContainer = styled.div`
  font-family: proxima-nova, sans-serif;

  padding: 7.5rem 0 6rem 0;
  width: 100%;
  display: flex;
  justify-content: center;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 3rem 2rem;
  }
`;

export const Title = styled.h2`
  font-family: proxima-nova, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: 115%;
  text-align: center;
  color: ${({ theme }) => theme.color.mobilityGrey};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    text-align: left;
  }
`;

export const Description = styled.p`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-align: center;
  color: ${({ theme }) => theme.color.mobilityGrey};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    text-align: left;
    font-size: 16px;
  }
`;
